import { render, staticRenderFns } from "./PostTiles.vue?vue&type=template&id=19403214&lang=pug"
import script from "./PostTiles.vue?vue&type=script&lang=ts"
export * from "./PostTiles.vue?vue&type=script&lang=ts"
import style0 from "./PostTiles.vue?vue&type=style&index=0&id=19403214&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports